import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/utils/api';
import { ProfileFees, PricePoint, ProvenanceEntry, HashtagEntry } from '../slices/profileSlice';

interface FeesResponse {
  success: boolean;
  profileId: string;
  fees: ProfileFees;
}

/**
 * Fetch on-chain fees for a creator's profile.
 * Calls GET /blockchain-profiles/creator/:userId/fees
 */
export const fetchPriceHistory = createAsyncThunk<PricePoint[], string>(
  'profile/fetchPriceHistory',
  async (username, { rejectWithValue }) => {
    try {
      const { data } = await api.get<{ history: PricePoint[] }>(`/user-profile/${username}/price-history`);
      return data.history;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to load price history');
    }
  }
);

export const fetchTopHashtags = createAsyncThunk<HashtagEntry[], string>(
  'profile/fetchTopHashtags',
  async (username, { rejectWithValue }) => {
    try {
      const { data } = await api.get<{ hashtags: HashtagEntry[] }>(`/user-profile/${username}/top-hashtags`);
      return data.hashtags;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to load hashtags');
    }
  }
);

export const fetchProvenance = createAsyncThunk<ProvenanceEntry[], string>(
  'profile/fetchProvenance',
  async (username, { rejectWithValue }) => {
    try {
      const { data } = await api.get<{ provenance: ProvenanceEntry[] }>(`/user-profile/${username}/provenance`);
      return data.provenance;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to load provenance');
    }
  }
);

export const fetchProfileFees = createAsyncThunk<ProfileFees, string>(
  'profile/fetchProfileFees',
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await api.get<FeesResponse>(`/blockchain-profiles/creator/${userId}/fees`);
      return data.fees;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to load profile fees');
    }
  }
);
